define('utils/forms',['require', 'jquery', 'source/sourcecompleter', 'utils/common', 'form/jquery.validator', 'form/jquery.multiply', 'form/selector'], function (require, $, SourceCompleter) {
	$(document).ready(function () {
		//Initialiseer formulieren
	    $('form').validator();
		$('.multiple').multiply();
	    
	    $('.multiselect').each(function(){
	    	var parent_form = $(this).closest('form');
	    	var input = $(this).children('input');
			var slr = input.formSelector({
				multiSelect: $(this).data('multiselect'),
				onlyExists: $(this).data('onlyexists'),
				source : new SourceCompleter({
					url : $(this).data('url'),
					name : $(this).data('name'),
					selector : '#'+input.attr('id'),
					value : 'name'
				})
			}).data('selector');
	    });

		if($('.filewidget').exists()) {
	    	require(['form/file'], function(File) {
	    		$('.filewidget').each(function () {
	    			new File({
	    				widget : $(this),
	    				enableUpload : $(this).data('upload') == 1,
	    				manageRights : $(this).data('rights') == 1,
	    				script : $(this).data('script')
		    		});	    			
	    		});
	    		
	    	});
	    }
		
	    if ($('.dateField, .datetimeField, .timeField').exists())
	    	require(['form/datetimepicker']);
	});
});
